import React from 'react';

export const AmbassadorBadgeIcon = ({ width = 160, height = 160 }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 161 160"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_i_546_653)">
      <path
        d="M58.018 24.1728C69.4526 11.3077 89.5536 11.3077 100.988 24.1728C105.105 28.8045 110.608 31.9819 116.678 33.2313C133.537 36.7014 143.587 54.1094 138.163 70.4446C136.21 76.3257 136.21 82.6805 138.163 88.5616C143.587 104.897 133.537 122.305 116.678 125.775C110.608 127.024 105.105 130.202 100.988 134.833C89.5536 147.698 69.4526 147.698 58.018 134.833C53.9012 130.202 48.3978 127.024 42.3282 125.775C25.4694 122.305 15.4189 104.897 20.843 88.5616C22.7959 82.6805 22.7959 76.3257 20.8431 70.4446C15.4189 54.1094 25.4694 36.7014 42.3282 33.2313C48.3978 31.9819 53.9012 28.8045 58.018 24.1728Z"
        fill="#FCA6DB"
      />
      <path
        d="M58.018 24.1728C69.4526 11.3077 89.5536 11.3077 100.988 24.1728C105.105 28.8045 110.608 31.9819 116.678 33.2313C133.537 36.7014 143.587 54.1094 138.163 70.4446C136.21 76.3257 136.21 82.6805 138.163 88.5616C143.587 104.897 133.537 122.305 116.678 125.775C110.608 127.024 105.105 130.202 100.988 134.833C89.5536 147.698 69.4526 147.698 58.018 134.833C53.9012 130.202 48.3978 127.024 42.3282 125.775C25.4694 122.305 15.4189 104.897 20.843 88.5616C22.7959 82.6805 22.7959 76.3257 20.8431 70.4446C15.4189 54.1094 25.4694 36.7014 42.3282 33.2313C48.3978 31.9819 53.9012 28.8045 58.018 24.1728Z"
        fill="url(#paint0_radial_546_653)"
        fill-opacity="0.3"
      />
    </g>
    <path
      d="M47.9162 31.0527L48.5537 32.3767L47.9162 31.0527L53.1162 28.5489C53.4992 28.3645 53.862 28.1408 54.1988 27.8815L66.8523 18.1386C68.2736 17.0442 69.9802 16.3826 71.7679 16.233L84.3485 15.1804C86.1595 15.0289 87.9754 15.4094 89.5732 16.2752L96.5144 20.0366L95.7998 21.3554L96.5144 20.0366C97.1199 20.3647 97.5639 20.9274 97.7421 21.5926C97.8679 22.0622 97.8546 22.5582 97.7037 23.0203L93.6225 35.5185C92.896 37.7433 91.0944 39.4504 88.8338 40.0562C86.9326 40.5656 85.7034 42.4051 85.9602 44.3565L89.7124 72.8693C90.508 78.915 82.0487 81.1662 79.734 75.5249L69.344 50.2032C68.6342 48.4733 66.7497 47.5401 64.9437 48.0241C62.565 48.6614 60.0282 47.9459 58.3331 46.1596L47.2814 34.5128M47.9162 31.0527L47.2814 34.5128M47.9162 31.0527C46.9734 31.5066 46.4869 32.567 46.7578 33.5777C46.8517 33.9282 47.0317 34.2496 47.2814 34.5128M47.9162 31.0527L47.2814 34.5128"
      stroke="url(#paint1_linear_546_653)"
      stroke-width="3"
    />
    <path
      d="M63.7301 18.9787C62.985 19.2244 62.4139 19.8289 62.2108 20.5867C62.0759 21.0903 62.1139 21.6246 62.3189 22.1039L68.2142 35.8943C69.0762 37.9106 70.8163 39.4194 72.9344 39.987C74.9433 40.5252 76.2422 42.469 75.9708 44.5309L72.244 72.8504C71.4484 78.8961 79.9076 81.1475 82.2224 75.5061L92.6726 50.0377C93.348 48.3917 95.141 47.5038 96.8596 47.9642C99.3478 48.6309 101.996 47.7741 103.621 45.776L112.598 34.7443C112.799 34.4973 112.945 34.2106 113.027 33.903C113.288 32.9317 112.875 31.9052 112.014 31.3848L102.926 25.8886C102.626 25.7071 102.341 25.5009 102.075 25.2722L95.0495 19.2336C93.7182 18.0893 92.0911 17.3437 90.3552 17.0824L78.2225 15.2561C76.7764 15.0384 75.2994 15.1636 73.9105 15.6216L63.7301 18.9787Z"
      stroke="url(#paint2_linear_546_653)"
      stroke-width="3"
    />
    <path
      d="M105.021 30.8918L103.883 29.9144L105.021 30.8918C105.399 30.4521 105.606 29.8915 105.606 29.3118C105.606 28.6574 105.342 28.0308 104.873 27.5744L97.9635 20.8478C97.0839 19.9915 96.044 19.3171 94.9033 18.8632L86.5263 15.5305C82.8417 14.0646 78.7659 13.9066 74.9789 15.083L65.9725 17.8807C64.6573 18.2893 63.4488 18.9839 62.4338 19.9146L54.7002 27.0058C54.1202 27.5375 53.7901 28.2882 53.7901 29.0751C53.7901 29.8617 54.1201 30.6123 54.6998 31.1441L62.4263 38.231C63.9521 39.6305 65.9473 40.407 68.0178 40.407C70.7033 40.407 72.9596 42.4255 73.2574 45.0944L75.8959 68.737C76.5447 74.5511 84.9955 74.5509 85.6443 68.7369L88.3176 44.7826C88.5956 42.2912 90.7018 40.407 93.2086 40.407C95.5181 40.407 97.7125 39.3991 99.2174 37.6474L105.021 30.8918Z"
      fill="black"
      stroke="#F697D2"
      stroke-width="3"
    />
    <path
      d="M80.6997 49.3468C77.853 49.3468 75.8429 52.1357 76.7431 54.8363L78.9256 61.3839C79.1802 62.1475 79.8948 62.6626 80.6997 62.6626C81.5046 62.6626 82.2192 62.1475 82.4738 61.3839L84.6563 54.8363C85.5565 52.1357 83.5464 49.3468 80.6997 49.3468Z"
      fill="#FDD1EC"
      stroke="#FCA9DC"
      stroke-width="1.56656"
    />
    <path
      d="M87.2216 115.055L87.2248 115.052L87.4579 114.844C97.496 105.909 105.952 98.3818 111.894 91.2612C117.898 84.066 121.5 77.0964 121.5 69.2807C121.5 56.506 111.24 46.5 98.275 46.5C91.6895 46.5 85.5668 50.9074 81.265 55.2801C80.8514 55.7006 80.1486 55.7006 79.735 55.2801C75.4332 50.9074 69.3105 46.5 62.725 46.5C49.7599 46.5 39.5 56.506 39.5 69.2807C39.5 77.0964 43.1022 84.0661 49.1064 91.2567C55.0689 98.3973 63.5628 105.942 73.6464 114.899L73.7742 115.012L73.7764 115.014L78.2033 118.962C79.5112 120.128 81.4846 120.132 82.7968 118.97L87.2216 115.055Z"
      fill="black"
      stroke="#F697D2"
      stroke-width="3"
    />
    <g filter="url(#filter1_i_546_653)">
      <path
        d="M58.018 24.1728C69.4526 11.3077 89.5536 11.3077 100.988 24.1728V24.1728C105.105 28.8045 110.608 31.9819 116.678 33.2313V33.2313C133.537 36.7014 143.587 54.1094 138.163 70.4446V70.4446C136.21 76.3257 136.21 82.6805 138.163 88.5616V88.5616C143.587 104.897 133.537 122.305 116.678 125.775V125.775C110.608 127.024 105.105 130.202 100.988 134.833V134.833C89.5536 147.698 69.4526 147.698 58.018 134.833V134.833C53.9012 130.202 48.3978 127.024 42.3282 125.775V125.775C25.4694 122.305 15.4189 104.897 20.843 88.5616V88.5616C22.7959 82.6805 22.7959 76.3257 20.843 70.4446V70.4446C15.4189 54.1094 25.4694 36.7014 42.3282 33.2313V33.2313C48.3978 31.9819 53.9012 28.8045 58.018 24.1728V24.1728Z"
        stroke="#ED6CBB"
        stroke-width="3.97515"
      />
    </g>
    <defs>
      <filter
        id="filter0_i_546_653"
        x="19.3666"
        y="14.524"
        width="120.273"
        height="141.316"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="11.3576" />
        <feGaussianBlur stdDeviation="11.3576" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.12 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect1_innerShadow_546_653"
        />
      </filter>
      <filter
        id="filter1_i_546_653"
        x="17.3783"
        y="12.5364"
        width="124.25"
        height="145.291"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="11.3576" />
        <feGaussianBlur stdDeviation="11.3576" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.12 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect1_innerShadow_546_653"
        />
      </filter>
      <radialGradient
        id="paint0_radial_546_653"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(79.5031 18.5935) rotate(90) scale(92.3262)"
      >
        <stop stop-color="white" />
        <stop offset="1" stop-color="white" stop-opacity="0" />
      </radialGradient>
      <linearGradient
        id="paint1_linear_546_653"
        x1="71.5059"
        y1="17.408"
        x2="93.8567"
        y2="100.822"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#E56AB6" stop-opacity="0.75" />
        <stop offset="1" stop-color="#F697D2" stop-opacity="0" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_546_653"
        x1="92.3617"
        y1="17.9014"
        x2="70.0109"
        y2="101.316"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#E56AB6" stop-opacity="0.75" />
        <stop offset="1" stop-color="#F697D2" stop-opacity="0" />
      </linearGradient>
    </defs>
  </svg>
);
